import React from 'react'

const useGeometricButtonTheme = () => {
  const geometricButtonTheme = [
    {
      class: 'border-[1px] border-v8-line pb-2',
      buttons:
        'α β γ δ ε ζ η η θ ι del κ λ μ ν ξ ο π ρ σ τ abc υ φ χ ψ ω I V X C D space M',
    },
    {
      class: 'bg-white',
      layout: 'hg-theme-default',
    },
    {
      class: 'ms-[15px]',
      buttons: 'α abc',
    },
    {
      class: 'text-white',
      buttons: 'del',
    },
    {
      class: 'w-[220px]',
      buttons: 'space',
    },
    {
      class: 'ms-[100px]',
      buttons: 'D',
    },
    {
      class: 'bg-[#444CE7] text-white',
      buttons: 'abc',
    },
    {
      class: 'me-[40px]',
      buttons: '&#8730',
    },
    {
      class: `bg-[url('/images/sqaure_root.png')] bg-no-repeat bg-center v-none`,
      buttons: '&#8730',
    },
    {
      class: `bg-[url('/images/I1.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I1',
    },
    {
      class: `bg-[url('/images/I2.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I2',
    },
    {
      class: `bg-[url('/images/I3.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I3',
    },
    {
      class: `bg-[url('/images/I4.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I4',
    },
    {
      class: `bg-[url('/images/I5.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I5',
    },
    {
      class: `bg-[url('/images/I6.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I6',
    },
    {
      class: `bg-[url('/images/I7.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I7',
    },
    {
      class: `bg-[url('/images/I8.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I8',
    },
    {
      class: `bg-[url('/images/I10.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I10',
    },
    {
      class: `bg-[url('/images/I9.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I9',
    },
    {
      class: `bg-[url('/images/I11.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I11',
    },
    {
      class: `bg-[url('/images/I12.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I12',
    },
    {
      class: `bg-[url('/images/I13.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I13',
    },
    {
      class: `bg-[url('/images/I14.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I14',
    },
    {
      class: `bg-[url('/images/I15.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I15',
    },
    {
      class: `bg-[url('/images/I16.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I16',
    },
    {
      class: `bg-[url('/images/I17.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I17',
    },
    {
      class: `bg-[url('/images/I18.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I18',
    },
    {
      class: `bg-[url('/images/I19.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I19',
    },
    {
      class: `bg-[url('/images/I20.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I20',
    },
    {
      class: `bg-[url('/images/I21.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I21',
    },
    {
      class: `bg-[url('/images/I22.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I22',
    },
    {
      class: `bg-[url('/images/I23.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I23',
    },
    {
      class: `bg-[url('/images/I24.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I24',
    },
    {
      class: `bg-[url('/images/I25.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I25',
    },
    {
      class: `bg-[url('/images/I26.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I26',
    },
    {
      class: `bg-[url('/images/I27.png')] bg-no-repeat bg-center v-none`,
      buttons: 'I27',
    },
    {
      class: 'ms-[100px]',
      buttons: 'abc',
    },
    {
      class: 'ms-[15px]',
      buttons: 'I1 I20',
    },
    {
      class: 'me-[15px]',
      buttons: 'I19',
    },
    {
      class: 'me-[40px]',
      buttons: 'M',
    },
    {
      class: 'bg-[#FF692E]',
      buttons: 'del',
    },

    {
      class: 'bg-[#444CE7]',
      buttons: '&#946 &#x222B &#8730',
    },
    {
      class: 'text-white',
      buttons: '&#946 &#x222B &#8730 {arrowup}',
    },
    {
      class: `bg-[url('/images/I19.png')] bg-no-repeat bg-center v-none`,
      buttons: 's6',
    },
  ]
  return { geometricButtonTheme }
}

export default useGeometricButtonTheme
